/**
 * Chatbot configuration.
 *
 * ⚠️  IMPORTANT: Never commit a real API key to a public repository.
 *     For production, inject this value via an environment variable
 *     (e.g. GATSBY_GEMINI_API_KEY) at build time instead.
 *
 * Get your free key at https://aistudio.google.com/apikey
 */

const GEMINI_API_KEY =
  process.env.GATSBY_GEMINI_API_KEY || 'AIzaSyBpf7VX39wQyEWUgPHgDFMYrBnUiCKcKeE';

/**
 * Ordered list of lightweight/fast models to try.
 * If the first model returns a 429 (rate limit) or 503 (overloaded),
 * the service automatically falls through to the next model.
 */
const GEMINI_MODELS = [
  // 'gemini-2.5-flash',
  'gemini-2.5-flash-lite',
  // 'gemini-2.5-pro',
];

export { GEMINI_API_KEY, GEMINI_MODELS };
